module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADOSURBVCiRlZMxDoJAEEX/bLD3CHAT6Qw0FmJN4AJ6Ar2BNyDU2tBo6PAm7hHsCTsWQLJuFmR/u//9zMzOEADEh+wKphTAGgAYLJ/3IsACedE+O4PpuMRsDSDq4a7tgroq5ZQxTvKGwb5qVaj7xFj2HDxoQyBfrESz3aW+HuAkM8SzmaIkexPIt70ZIaG1gjnYDHFuwZQ1gMHyH8hgqVoVWmdgW6I4ydmE66qUzi3oMNC38AEA/W8n9DJhAKDhDn5W2eUWxONWnJj5Mlbiqi9rVWGjc+aPJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logout.png
// module id = EUYG
// module chunks = 1